<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        مشاهده لیست حضور و غیاب
      </h4>
    </b-card-header>

    <b-card-body>
      <b-alert show
               variant="info">
        <div class="alert-body">
          <feather-icon
              class="mr-25"
              icon="InfoIcon"
          />
          <span class="ml-25">اطلاعات ورود و خروج هر <strong> ده دقیقه </strong> یکبار به روز می شود.</span>
        </div>
      </b-alert>

      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          :disabled="downloadingExcel"
          @click="downloadExcel"
      >
        <b-spinner v-if="downloadingExcel" small class="mr-50" />
        <feather-icon
            v-else
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>

      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>

      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent="advanceSearch">
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="users">
                    پرسنل (کد پرسنلی)
                  </label>
                  <b-overlay :show="loadingUsers" spinner-small>
                    <v-select
                        id="users"
                        v-model="search.users"
                        dir="rtl"
                        :options="usersList"
                        :getOptionLabel="user => user.personnel_no ? `${user.name} - ${user.personnel_no}` : user.name"
                        :reduce="user => user.id"
                        placeholder="انتخاب پرسنل..."
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group
                    label="از تاریخ"
                    label-for="from-date"
                >
                  <date-picker
                      id="from-date"
                      v-model="search.fromDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="jYYYYjMMjDD"
                      clearable
                  />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group
                    label="تا تاریخ"
                    label-for="to-date"
                >
                  <date-picker
                      id="to-date"
                      v-model="search.toDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      :min="search.fromDate"
                      format="jYYYYjMMjDD"
                      clearable
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <hr>

            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  :disabled="onProgress"
              >
                <b-spinner v-if="onProgress" small class="mr-50" />
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>

      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >
            <template #cell(cards)="data">
              <template v-if="data.value.length">
                <b-badge variant="light-info" class="ml-1" v-for="(card, index) in data.value" :key="index">
                  {{ card }}
                </b-badge>
              </template>

              <b-badge variant="light-danger" class="ml-1" v-else>
                بدون زمان
              </b-badge>
            </template>

            <template #cell(action)="data">
            </template>
          </b-table>
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination,
  BBadge,
  BButton,
  BSpinner,
  VBTooltip,
  BCollapse,
  BFormInput,
  BRow,
  BCol,
  BFormGroup,
  VBToggle,
  BTab,
  BTabs,
  BForm,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import {doubleRaf} from '@/libs/utils'
import aiCameraApi from '@api/ai-camera'

// آدرس وب‌سرویس — برای تغییر API فقط همین خط
const ATTENDANCE_ENDPOINT = 'attendances'

export default {
  name: 'ArchiveRequest',
  components: {
    BAlert,
    BTabs,
    BTab,
    BFormGroup,
    BCol,
    BRow,
    BFormInput,
    BCollapse,
    VSelect,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BBadge,
    BButton,
    BSpinner,
    BForm,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شماره پرسنلی',
        },
        {
          key: 'date',
          label: 'تاریخ حضور',
        },
        {
          key: 'cards',
          label: 'زمان های حضور',
        },
        {
          key: 'extraTime',
          label: 'اضافه کاری',
        },
        {
          key: 'abs',
          label: 'کسر کار',
        },
        {
          key: 'delay',
          label: 'تأخیر',
        },
        {
          key: 'vacation',
          label: 'مرخصی',
        },
        {
          key: 'description',
          label: 'توضیحات',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      loadingUsers: false,
      downloadingExcel: false,
      usersList: [],
      // پارامترهای آخرین درخواستی که واقعاً زده شده (مبنای خروجی اکسل)
      lastParams: {},
      search: {
        users: null,
        fromDate: '',
        toDate: '',
      },
    }
  },
  mounted() {
    // ورود به صفحه: درخواست بدون هیچ پارامتری
    this.getAttendanceList()
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      this.loadingUsers = true
      try {
        const {data} = await aiCameraApi.getUsers()
        this.usersList = data.data || []
      } catch (error) {
        console.error('Error loading users:', error)
      } finally {
        this.loadingUsers = false
      }
    },

    // فقط پارامترهای پرشده ارسال می‌شوند
    buildParams() {
      const params = {}

      if (this.search.users) params.users = this.search.users
      if (this.search.fromDate) params.fromDate = this.search.fromDate
      if (this.search.toDate) params.toDate = this.search.toDate

      return params
    },

    getAttendanceList(params = {}) {
      this.onProgress = true
      this.lastParams = params

      this.$http.get(ATTENDANCE_ENDPOINT, {params})
          .then(({data}) => {
            if (data.status) {
              this.items = data.data
            } else {
              this.items = []
              this.$bvToast.toast(data.message ?? 'لیست حضور غیاب دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.items = []
            this.$bvToast.toast(error.response?.data?.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },

    advanceSearch() {
      this.getAttendanceList(this.buildParams())

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },

    clearSearch() {
      this.search = {
        users: null,
        fromDate: '',
        toDate: '',
      }

      this.getAttendanceList()

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },

    async downloadExcel() {
      this.downloadingExcel = true
      try {
        // دقیقاً همان درخواست فعلی (با یا بدون فیلتر) + export=1
        const response = await this.$http.get(ATTENDANCE_ENDPOINT, {
          params: {
            ...this.lastParams,
            export: 1,
          },
          responseType: 'blob',
        })

        const blob = new Blob([response.data], {
          type: response.data.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `attendances-${new Date().getTime()}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.$bvToast.toast('دریافت فایل اکسل انجام نشد', {
          title: 'خطا در خروجی اکسل',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
      } finally {
        this.downloadingExcel = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

.border {
  border: 1px solid #ebe9f1 !important;
}
</style>